<template>
    <div class="auth-box screen-center px-5 pt-5 pb-0">
        <!-- Alert Messages -->
        <div v-if="msg !== ''" :class="`alert alert-${color} text-center p-1`" role="alert">
            <i class="fas fa-exclamation-circle"></i> {{ msg }}
        </div>
        <div v-if="verified" class="text-center">
            <small class="text-dark-green text-uppercase">redirecting you in</small>
            <h4>{{countdown}}</h4>
        </div>
        <div v-else class="text-center">
            <button @click="userVerifyEmail" class="loadn btn btn-dark-green">Verify Email</button>
        </div>
        <h5 class="text-dark-green text-center mt-5">
            <router-link :to="{ name: 'home' }">&copy;aNewItem</router-link>
        </h5>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { webpageTitle } from '@/store/dry'

import LayoutAuth from '@/layouts/Auth.vue' 

export default {
    name: "VerifyEmail",
    data() {
        return {
            msg: '',
            color: 'danger',
            verified: false,
            countdown: 3
        }
    },
    methods: {
        ...mapActions(['verifyEmail']),
        userVerifyEmail() { 
            this.color = 'danger'
            if(!this.$route.params.code || !this.$route.params.userId) { 
                this.msg = "You are required to click on the verification link in your email inbox!"; 
                return 
            }
            let userObj = {
                userId: this.$route.params.userId,
                confToken: this.$route.params.code
            }
            this.verifyEmail(userObj)
            .then((data) => {
                if(!data.error){
                    this.color = 'success'
                    this.verified = true
                    this.runCountdown()
                }
                this.msg = data.msg
            })
            .catch((e) => {
                this.msg = "We are having issues reaching our resoruces at this time. Check back soon."
            })
        },
        runCountdown(){
            let x = this.countdown
            let y = setInterval(() => {
                x -= 1
                this.countdown = x
                if(x < 1){ 
                    clearInterval(y)
                    this.countdown = 0 
                    // redirect to profile if user was loggedIn
                    if(this.authenticated){
                        this.$router.push({ name: 'profile' }).catch((e) => {})
                    }
                    // redirect to signIn if user was not loggedIn
                    else {
                        this.$router.push({ name: 'signin' }).catch((e) => {})
                    }
                }
            }, 1000)
        }
    },
    computed: {
        ...mapGetters(['authenticated'])
    },
    created() {
        webpageTitle(`Email verification`)
        this.$emit('update:layout', LayoutAuth);
        this.userVerifyEmail();
    }
}
</script>